import EntityState from '@/data/EntityState';
import { LIST_INDUSTRIES } from '@/store/action-types';
import Industry from './model';

import { Map } from 'immutable';

export default function (state = new EntityState(), action) {
  switch (action.type) {
    case LIST_INDUSTRIES.FAILURE:
      return state.merge({
        loaded: false,
        loading: false,
        error: action.payload,
      });
    case LIST_INDUSTRIES.REQUEST:
      return state.merge({
        loaded: false,
        loading: true,
        error: null,
      });
    case LIST_INDUSTRIES.SUCCESS:
      return state.merge({
        loaded: true,
        loading: false,
        error: null,
        items: new Map(action.payload.map(industry => [industry.id, new Industry(industry)])),
      });
    default:
      return state;
  }
}
